<script lang="ts">
	import '../app.css';
	import Header from '$lib/components/Header.svelte';
	import FooterSection from '$lib/sections/FooterSection.svelte';
	import { page } from '$app/state';
	import { afterNavigate } from '$app/navigation';
	import { browser } from '$app/environment';

	let { children } = $props();

	const isDocsPage = $derived(page.url.pathname.startsWith('/docs'));
	const isLearnPage = $derived(page.url.pathname.startsWith('/learn'));
	const isOnboardingPage = $derived(page.url.pathname.startsWith('/onboarding'));
	// `?capture=1` suppresses dev-only affordances (dev panels)
	// so the screenshot pipeline renders the page exactly as a real visitor sees it.
	// Guarded by `browser` because SvelteKit forbids `url.searchParams` access during
	// prerender — only one HTML output per route, so query params can't influence it.
	const isCapture = $derived(browser && page.url.searchParams.get('capture') === '1');

	let scrollContainer: HTMLDivElement | undefined = $state();

	afterNavigate(({ to }) => {
		if (!to?.url.hash && scrollContainer) {
			scrollContainer.scrollTo(0, 0);
		}
	});
</script>

{#if isDocsPage || isLearnPage || isOnboardingPage}
	{@render children()}
{:else}
	<!-- Outer wrapper: fixed height, no scroll (prevents body scroll) -->
	<div class="h-screen flex flex-col overflow-hidden">
		<Header />

		<!-- Inner scroll container: this is what scrolls, enabling transparent scrollbar -->
		<div bind:this={scrollContainer} class="relative flex-1 overflow-y-auto overflow-x-clip bg-[#F9F9F4]">
			{@render children()}
			<FooterSection />
		</div>
	</div>
{/if}
